import * as actionTypes from "../actions/actionTypes";
import {
  COMPANY_STATIC_FIELDS,
  COMPANY_FIELDS_BY_COUNTRY,
  COMPANY_DYNAMIC_FIELDS,
  EU_COUNTRIES,
} from "../../constants";

const initialState = {
  organization: null,
  error: false,
  loading: false,
  isShowModal: false,
  accountId: null,
  id: null,
  details: null,
  detailsId: null,
  invoices: null,
  invoices_legacy: null,
  invoiceData: null,
  vies: true,
  creditNotes: null,
  creditNoteData: null,
  status: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ORGANIZATION:
      let isFull = true;

      // This inside map(... is written exactly like this for not lose isFull = false from previous iteration
      // isFull = isFull && true;

      const fieldsData = {};
      const { account_id, id, vies, status, ...organization } =
        action.organization;

      const fields = [
        ...COMPANY_STATIC_FIELDS,
        ...(COMPANY_FIELDS_BY_COUNTRY[organization.country]
          ? COMPANY_FIELDS_BY_COUNTRY[organization.country].filter((field) =>
              COMPANY_DYNAMIC_FIELDS.includes(field)
            )
          : []),
      ];

      fields.map((field) => {
        // vat required for Italy and other EU
        if (
          [...EU_COUNTRIES, "it"].includes(organization.country) &&
          field === "vat"
        ) {
          isFull = isFull && true;
          //only for Italy
          //certified_email not mandatory if we have unique_code
        } else if (
          organization.country === "it" &&
          organization.certified_email &&
          field === "unique_code" &&
          !organization.unique_code
        ) {
          isFull = isFull && true;
          // opposite for previous
        } else if (
          organization.country === "it" &&
          organization.unique_code &&
          field === "certified_email" &&
          !organization.certified_email
        ) {
          isFull = isFull && true;
          //for now only for Finland nif - not required
        } else if (organization.country === "fi" && field === "nif") {
          isFull = isFull && true;
        } else if (field === "unique_code") {
          //unique_code hotfix, not mandatory for now
          isFull = isFull && true;
        } else {
          //in other case is form filled depends on value present
          // if value is missed or  === "" it will make isFull= false -> show modal
          isFull = isFull && organization[field];
        }
        fieldsData[field] = organization[field];
      });

      return {
        ...state,
        accountId: account_id,
        organization: fieldsData,
        error: false,
        isEmpty: action.isEmpty,
        loading: false,
        isShowModal: !isFull,
        id: id,
        vies: vies,
        status: status,
      };
    case actionTypes.ADD_ORGANIZATION:
      return {
        ...state,
        id: action.id,
        error: false,
      };
    case actionTypes.UPDATE_ORGANIZATION:
      return {
        ...state,
        error: false,
      };
    case actionTypes.FETCH_ORGANIZATION_STARTING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case actionTypes.FETCH_ORGANIZATION_FAILED:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case actionTypes.SET_ORGANIZATION_DETAILS:
      return {
        ...state,
        error: false,
        details: action.details,
        detailsId: action.details.id,
      };
    case actionTypes.SET_INVOICES_LEGACY:
      return {
        ...state,
        error: false,
        invoices_legacy: action.invoices,
      };
    case actionTypes.SET_INVOICES:
      return {
        ...state,
        error: false,
        invoices: action.invoices,
      };
    case actionTypes.SET_INVOICE_LEGACY:
      return {
        ...state,
        invoiceData: action.invoiceData,
      };
    case actionTypes.SET_CREDIT_NOTES:
      return {
        ...state,
        error: false,
        creditNotes: action.creditNotes,
      };
    case actionTypes.SET_CREDIT_NOTE:
      return {
        ...state,
        creditNoteData: action.creditNoteData,
      };
    default:
      return state;
  }
};

export default reducer;
